export default __webpack_public_path__ + "static/media/ic_person_outline_48px.3d596488.svg";